import { render, staticRenderFns } from "./LikertScaleQuestion.vue?vue&type=template&id=bbdf34f2&"
import script from "./LikertScaleQuestion.vue?vue&type=script&lang=js&"
export * from "./LikertScaleQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports